import React from 'react';
import styles from './Input.module.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className = '', ...props }: InputProps) {
  return (
    <div className={styles.wrapper}>
      {label && <label className={styles.label}>{label}</label>}
      <input
        className={[
          styles.input,
          error ? styles['has-error'] : '',
          className,
        ].filter(Boolean).join(' ')}
        {...props}
      />
      {error && <p className={styles['error-text']}>{error}</p>}
    </div>
  );
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export function Textarea({ label, error, className = '', ...props }: TextareaProps) {
  return (
    <div className={styles.wrapper}>
      {label && <label className={styles.label}>{label}</label>}
      <textarea
        className={[
          styles.textarea,
          error ? styles['has-error'] : '',
          className,
        ].filter(Boolean).join(' ')}
        {...props}
      />
      {error && <p className={styles['error-text']}>{error}</p>}
    </div>
  );
}
